/* EZY LION — Ajax cart handler
 * Loads once, handles all .gin-card__btn--ajax clicks across the page.
 * (c) EZY LION. All rights reserved. */
(function() {
  if (window.__ginAjaxCartInit) return;
  window.__ginAjaxCartInit = true;

  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('.gin-card__btn--ajax');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.dataset.variantId;
    const textEl = btn.querySelector('.gin-card__btn-text');
    const originalText = textEl ? textEl.textContent : 'Add To Cart';

    btn.disabled = true;
    btn.classList.add('gin-card__btn--loading');
    if (textEl) textEl.textContent = 'Adding...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      });

      if (res.ok) {
        if (textEl) textEl.textContent = 'Added \u2713';
        btn.classList.remove('gin-card__btn--loading');
        btn.classList.add('gin-card__btn--added');

        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            document.querySelectorAll('.cart-count-bubble, .cart-count, [data-cart-count]')
              .forEach(b => { b.textContent = cart.item_count; });
          });

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        setTimeout(() => {
          if (textEl) textEl.textContent = originalText;
          btn.disabled = false;
          btn.classList.remove('gin-card__btn--added');
        }, 1800);

      } else {
        const err = await res.json();
        if (textEl) textEl.textContent = err.description || 'Error';
        setTimeout(() => {
          if (textEl) textEl.textContent = originalText;
          btn.disabled = false;
          btn.classList.remove('gin-card__btn--loading');
        }, 2000);
      }
    } catch(err) {
      if (textEl) textEl.textContent = 'Error';
      setTimeout(() => {
        if (textEl) textEl.textContent = originalText;
        btn.disabled = false;
        btn.classList.remove('gin-card__btn--loading');
      }, 2000);
    }
  });
})();